import { Datagrid, List, TextField } from 'react-admin';
import * as React from 'react';
import { DEFAULT_LOCALE } from '../../helpers/consts';

export const PerpStatusesList = (props: any) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField label={'Name'} source={`name.${DEFAULT_LOCALE}`} />
      </Datagrid>
    </List>
  );
};
